export default __webpack_public_path__ + "static/media/white_house_icon.d8c6f9fc.svg";